import { sprintf } from 'sprintf-js';

import { apiInstance } from 'api/utils';

const URLS = {
  SUSPEND: '/bexio/integration/%s/suspend/',
  RETRIEVE: '/bexio/integration/%s/activate/',
};

export default {
  suspendAccount: ({ bexioUserUuid }: { bexioUserUuid: string }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.SUSPEND, bexioUserUuid),
    }),
  retrieveAccount: ({ bexioUserUuid }: { bexioUserUuid: string }) =>
    apiInstance.request({
      method: 'POST',
      url: sprintf(URLS.RETRIEVE, bexioUserUuid),
    }),
};
